let kinet;
const colorMax = 192;

// gets the breakpoint at which the scroll-to-top button should appear
const scrollBreakpoint = window.innerHeight * 0.9;

document.addEventListener('DOMContentLoaded', () => {
    randomizeBackgrounds();
    setupScrollListener();
    setupScrollEvent();
});

function setupScrollEvent() {
    const scrollButton = document.querySelector('.scroll-top');

    scrollButton.addEventListener('click', (e) => {
        // not the best solution until Safari/Edge support scroll behavior
        // window.scrollTo({ top: 0, behavior: 'smooth' });

        // Thanks to Geroge Daniel https://stackoverflow.com/questions/51229742/javascript-window-scroll-behavior-smooth-not-working-in-safari
        smoothVerticalScrolling(document.body, 250, "top");
    });
}

// prepares the window for a scroll event to show the scroll button
function setupScrollListener() {
    window.addEventListener('scroll', (e) => {
        const scrollButton = document.querySelector('.scroll-top');

        // const scrollOffset = document.scrollingElement.scrollTop;
        const scrollOffset = window.scrollY;

        if (scrollOffset >= scrollBreakpoint) {
            scrollButton.classList.add('visible');
        } else if (scrollOffset <= 0) {
            scrollButton.classList.remove('visible');
        }
    });
}

function randomizeBackgrounds() {
    // get all the content containers
    const contentContainers = document.querySelectorAll('.content-container');

    [].forEach.call(contentContainers, container => {
        // assign random background
        container.style.background = `rgb(${randVal(colorMax)},${randVal(colorMax)},${randVal(colorMax)})`;
    });
}

// random between 0 to max
function randVal(max) {
    return Math.floor(Math.random() * Math.floor(max));
}

// uses a timeout to scroll to top
function smoothVerticalScrolling(e, time, where) {
    // gets the element's top position relative to the viewport
    const eTop = e.getBoundingClientRect().top;

    // divides the top offset into 100 steps to be ellapsed
    const eAmt = eTop / 100;

    // starting time
    let curTime = 0;

    // not to exceed the desired duration
    while (curTime <= time) {
        // call a function to execute at one hundreth of the desired scroll time
        window.setTimeout(SVS_B, curTime, eAmt, where);
        // increase by one hundreth of the desired time to execute exactly 100 times
        curTime += time / 100;
    }
}

function SVS_B(eAmt, where) {
    // scroll by half the hundredth of the top offset if destination is not top (since to center only involves scrolling either in the top or bottom half of the window)
    if (where == "center" || where == "") {
        window.scrollBy(0, eAmt / 2);
    }
    // otherwise scroll the full amount
    if (where == "top") {
        window.scrollBy(0, eAmt);
    }
}

let dsSwiper;
let storyLineSwiper;
let beforeAfterSwiper;
!(function ($) {
    "use strict";

    // Smooth scroll for the navigation menu and links with .scrollto classes
    var scrolltoOffset = $('#header').outerHeight() - 1;
    $(document).on('click', '.nav-menu a, .mobile-nav a, .scrollto', function (e) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            if (target.length) {
                e.preventDefault();

                var scrollto = target.offset().top - scrolltoOffset;

                if ($(this).attr("href") == '#header') {
                    scrollto = 0;
                }

                $('html, body').animate({
                    scrollTop: scrollto
                }, 1500, 'easeInOutExpo');

                if ($(this).parents('.nav-menu, .mobile-nav').length) {
                    $('.nav-menu .active, .mobile-nav .active').removeClass('active');
                    $(this).closest('li').addClass('active');
                }

                if ($('body').hasClass('mobile-nav-active')) {
                    $('body').removeClass('mobile-nav-active');
                    $('.mobile-nav-toggle i').toggleClass('icofont-navigation-menu icofont-close');
                    $('.mobile-nav-overly').fadeOut();
                }
                return false;
            }
        }
    });

    // Activate smooth scroll on page load with hash links in the url
    $(document).ready(function () {
        if (window.location.hash) {
            var initial_nav = window.location.hash;
            if ($(initial_nav).length) {
                var scrollto = $(initial_nav).offset().top - scrolltoOffset;
                $('html, body').animate({
                    scrollTop: scrollto
                }, 1500, 'easeInOutExpo');
            }
        }

        $("#scroll-top").click(function () {
            $('html, body').animate({
                scrollTop: $("#2nd-sec").offset().top
            }, 100);
        });
    });


    // Navigation active state on scroll
    var nav_sections = $('section');
    var main_nav = $('.nav-menu, .mobile-nav');

    $(window).on('scroll', function () {
        // @TODO reset this
        return;
        var cur_pos = $(this).scrollTop() + 200;

        nav_sections.each(function () {
            var top = $(this).offset().top, bottom = top + $(this).outerHeight();

            if (cur_pos >= top && cur_pos <= bottom) {
                if (cur_pos <= bottom) {
                    main_nav.find('li').removeClass('active');
                }
                main_nav.find('a[href="#' + $(this).attr('id') + '"]').parent('li').addClass('active');
            }
            if (cur_pos < 300) {
                $(".nav-menu ul:first li:first, .mobile-menu ul:first li:first").addClass('active');
            }
        });
    });


    // Toggle .header-scrolled class to #header when page is scrolled
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100 || (window.innerWidth < 768 && window.scrollY > 27)) {
            $('#header').addClass('header-scrolled');
        } else {
            $('#header').removeClass('header-scrolled');
        }
    });

    if ($(window).scrollTop() > 100 || (window.innerWidth < 768 && window.scrollY > 27)) {
        $('#header').addClass('header-scrolled');
    }

    $(document).ready(function () {


        // customCursor();

        // Swiper: Slider
        // beforeAfterSwiper = new Swiper('.swiper-container', {
        //     loop: true,
        //     nextButton: '.swiper-button-next',
        //     prevButton: '.swiper-button-prev',
        //     slidesPerView: 1,
        //     simulateTouch: true,
        //     draggable: true,
        //     paginationClickable: true,
        //     centeredSlides: true, // spaceBetween: 120,
        //     initialSlide: 0,
        //     autoplay: 3000,
        //     breakpoints: {
        //         1920: {
        //             slidesPerView: 1, // spaceBetween: 120
        //         }, 1028: {
        //             slidesPerView: 1, // spaceBetween: 120
        //         }, 767: {
        //             slidesPerView: 1,
        //             spaceBetween: 0,
        //         }, 0: {
        //             slidesPerView: 1,
        //             spaceBetween: 0,
        //         }
        //     }
        // });

        // new Swiper('.swiper-packages', {
        //     slidesPerView: 3,
        //     autoplay: 5000,
        //     breakpoints: {
        //         1920: {
        //             slidesPerView: 3, // spaceBetween: 120
        //         }, 1028: {
        //             slidesPerView: 3, // spaceBetween: 120
        //         }, 767: {
        //             slidesPerView: 1,
        //         }, 0: {
        //             slidesPerView: 1,
        //             spaceBetween: 0,
        //         }
        //     }
        // });
        // new Swiper('.swiper-videos', {
        //     slidesPerView: 3,
        //     autoplay: 5000,
        //     spaceBetween: 10,
        //     breakpoints: {
        //         1920: {
        //             slidesPerView: 3, // spaceBetween: 120
        //         }, 1028: {
        //             slidesPerView: 3, // spaceBetween: 120
        //         }, 767: {
        //             slidesPerView: 1,
        //         }, 0: {
        //             slidesPerView: 1,
        //             spaceBetween: 0,
        //         }
        //     }
        // });
    });


    $(document).ready(function () {
        // Swiper: Slider
        // new Swiper('.swiper-container1', {
        //     loop: true,
        //     nextButton: '.swiper-button-next',
        //     prevButton: '.swiper-button-prev',
        //     slidesPerView: 3,
        //     paginationClickable: true,
        //     spaceBetween: 20,
        //     breakpoints: {
        //         1920: {
        //             slidesPerView: 3, spaceBetween: 30
        //         }, 1028: {
        //             slidesPerView: 1, spaceBetween: 30
        //         }, 480: {
        //             slidesPerView: 1, spaceBetween: 10
        //         }
        //     }
        // });


        const elem = document.querySelector('.case-studies-carousel');
        if (elem) {
            const flkty = new Flickity(elem, {
                contain: true,
                selectedAttraction: 0.01,
                friction: 0.25,
                wrapAround: true,
                imagesLoaded: true,
                cellAlign: "center",
                pageDots: false
            });
            flkty.on('dragMove', (event, pointer, moveVector) => {
                kinet.animate('x', event.pageX);
                kinet.animate('y', event.pageY);
            });

        }


        const elem2 = document.querySelector('.story-line');
        if (elem2) {
            storyLineSwiper = new Flickity(elem2, {
                contain: true,
                imagesLoaded: true,
                cellAlign: "center",
                prevNextButtons: false,
                pageDots: false
            });
        }
    });

    // dsSwiper = new Swiper(".different-systems", {
    //     slidesPerView: "auto", centeredSlides: true, // autoplay: true,
    // });

    setTimeout(() => {
        // dsSwiper.setProgress(0.02);
    }, 500);

    // dsSwiper.on('progress', () => {
    //     document.getElementById('swiper-range').value = dsSwiper.progress * 100;
    // })


    // function customCursor() {
    //
    //     kinet = new Kinet({
    //         acceleration: 0.1,
    //         friction: 0.70,
    //         names: ["x", "y"],
    //     });
    //
    //
    //     const swiperContainer = document.querySelector('.case-studies-carousel');
    //     if (swiperContainer) {
    //         const circle = document.getElementById('circle');
    //         swiperContainer.addEventListener('mouseenter', (event) => {
    //             circle?.classList?.add('active');
    //         })
    //         swiperContainer.addEventListener('mouseleave', (event) => {
    //             circle?.classList?.remove('active');
    //         });
    //
    //         kinet.on('tick', function (instances) {
    //             if (circle?.style) {
    //                 circle.style.left = `${(instances.x.current - 50)}px`;
    //                 circle.style.top = `${(instances.y.current - 50)}px`;
    //             }
    //         });
    //
    //         document.addEventListener('mousemove', function (event) {
    //             kinet.animate('x', event.pageX);
    //             kinet.animate('y', event.pageY);
    //         }, true);
    //
    //         document.addEventListener('wheel', (event) => {
    //             kinet.animate('x', event.pageX);
    //             kinet.animate('y', event.pageY);
    //         }, true);
    //     }
    //
    //
    // }


})(jQuery);

function sliderChanged(cropTarget) {
    dsSwiper.setProgress(cropTarget.value / 100);
}

const scrollKinet = new Kinet({
    names: ["x"],
    acceleration: 0.1,
    friction: 0.40,
});

let horizontalSlider = document.querySelector('.horizontal-slider');


horizontalSlider?.addEventListener('mousewheel', (e) => {
    horizontalSlider = document.querySelector('.horizontal-slider');
    document.getElementById('swiper-range').value = horizontalSlider.scrollLeft / (horizontalSlider.scrollWidth - horizontalSlider.clientWidth) * 100;
});


function updateAboutStoryLine(cropTarget) {
    // horizontalSlider.scrollLeft / (horizontalSlider.scrollWidth - horizontalSlider.clientWidth) * 100;
    horizontalSlider = document.querySelector('.horizontal-slider');
    let value = (cropTarget.value / 100) * (1850);
    scrollKinet.animate('x', value);
}


scrollKinet.on('tick', (instances) => {
    horizontalSlider.scroll(instances.x.current, 0);
});


